import type { CSSProperties } from "react";

import type { SafeHtmlAttributes } from "../../types/SafeHtmlAttributes";

import styles from "./Skeleton.module.scss";

const DEFAULT_SKELETON_HEIGHT = "24px";

export type SkeletonProps = SafeHtmlAttributes<HTMLDivElement> & {
  height?: CSSProperties["height"];
};

export const Skeleton = ({
  height = DEFAULT_SKELETON_HEIGHT,
  "aria-hidden": ariaHidden = true,
  ...rest
}: SkeletonProps) => {
  return (
    <div {...rest} aria-hidden={ariaHidden} className={styles.skeleton} style={{ height }}>
      <div aria-hidden="true" className={styles.highlight} />
    </div>
  );
};
